import '@babel/polyfill'

export default () => {

  const trainingEvents = document.querySelectorAll('.c-trainingEvents__item')
  const trainingEventsLinks = document.querySelectorAll('.c-trainingEvents__link')

  const urlVars = getUrlVars()
  var tastetest = false

  if(urlVars.tastetest){
    tastetest = urlVars.tastetest
    document.querySelector('[data-event-type="paid"]').classList.remove('-active')
    document.querySelector('[data-event-type="free"]').classList.add('-active')
    // hide onload
    trainingEvents.forEach( item => {
      if (item.dataset.eventType !== 'free') {
        item.classList.add('-hide')
      }
    })
  }else{
    //hide onload
    trainingEvents.forEach( item => {
      if (item.dataset.eventType !== 'paid') {
        item.classList.add('-hide')
      }
    })
  }

  const removeActive = () => {
    trainingEvents.forEach(event => {
      event.classList.remove('active')
    })
  }

  trainingEvents.forEach(event => {
    if(event.dataset.eventType == 'paid'){
      const toggle = event.querySelector(".js-event-toggle")

      if(toggle){
        toggle.addEventListener('click', () => {
          if(event.classList.contains("active")){
            removeActive()
          } else {
            removeActive()
            event.classList.add('active')
          }
        })
      }
    }
  });

  // add events for tabs
  trainingEventsLinks.forEach( tab => {
    tab.addEventListener('click', () => {
      switchTab(tab);
    })
  })

  function switchTab(currentTab) {
    trainingEventsLinks.forEach(item => {
      item.classList.remove('-active')
    })
    currentTab.classList.add('-active')
    
    trainingEvents.forEach(training => {
      if (training.dataset.eventType == currentTab.dataset.eventType) {
        training.classList.remove('-hide')
      } else {
        training.classList.add('-hide')
      }
    })
  }
}

function getUrlVars() {
	var vars = {}
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value
	})
	return vars
}